import React, { useContext } from 'react';
import Cookies from 'js-cookie';
import { GTM } from '@src/analytics/gtm';
import { gtmEvents } from '@src/analytics/gtmEventsConstant';
import { ELeadSquaredActivityCode } from '@src/constants/leadsquaredActivityConstants/index';
import {
  GlobalDispatchContext,
  GlobalStateContext,
} from '@src/context/GlobalContextProvider';
import useSendActivities from '@src/hooks/useSendActivities';
import { useCustomToast } from '@components/extra/useCustomToast';

// Without an onSubmitPageOne handler, LeadGenerationButton's `isOnePageForm`
// flow still falls through to the default submit path, which always
// advances to the "book a trial slot" second page — turning a plain
// "Request Callback" CTA back into the generic trial-booking flow. Passing
// this handler routes submission through the OTP "call me back" path
// instead (the same pattern NavRequestCallbackButton already uses
// site-wide), so the form stays a single callback request.
const useRequestCallback = () => {
  const state = useContext(GlobalStateContext);
  const dispatch = useContext(GlobalDispatchContext);
  const { sendActivityHandler } = useSendActivities();

  const triggerSuccessToast = useCustomToast(
    'success',
    <div>
      <h2 className="font-base font-rubik text-lg">Success!</h2>
      <p className="font-rubik text-xs">
        Thanks! We will give you a call or email you between 9 AM to 9 PM
      </p>
    </div>,
  );

  return function onSubmitPageOne(email, phone) {
    GTM.login({ userId: email, email, phone, whatsappNumber: phone });
    GTM.setEmail(email);

    if (!state.isEmailEventSubmitted) {
      GTM.track(gtmEvents.EMAIL_SUBMITTED, { type: 'CALL_ME_POPUP' });
      dispatch({ type: 'SET_IS_EMAIL_EVENT_SUBMITTED', payload: true });
    }

    sendActivityHandler(ELeadSquaredActivityCode.CALL_ME_BACK_SUBMITTED);

    window.webengage &&
      window.webengage.user.setAttribute('we_whatsapp_opt_in', true);

    if (Cookies.get('isPhoneVerified') === 'true') triggerSuccessToast();
  };
};

export default useRequestCallback;
